import { jsx } from "react/jsx-runtime";
import { Trigger, Anchor } from "@zillow/constellation";
import { event } from "@zillow/universal-analytics";
import { yieldCallback } from "@zillow/yield-callback";
import { usePageProps, getCmsInfoForPage } from "@zillow/zrs-cms";
import { uniq } from "lodash";
import { useContext } from "react";
import BlockModalDialog from "../blocks/ModalDialog/ModalDialog.esm.js";
import BlocksContext from "../components/BlockList/BlockContext.esm.js";
import { usePopulateParamPlaceHolders } from "./populateParamPlaceholders.esm.js";
function getBlockById(blocks, id) {
  let object;
  blocks.some(function iter(block) {
    var _a;
    if (((_a = block == null ? void 0 : block.attrs) == null ? void 0 : _a.id) === id) {
      object = block;
      return true;
    }
    return Array.isArray(block.innerBlocks) && block.innerBlocks.some(iter);
  });
  return object;
}
const isValidTrigger = (target) => /#(.*)/gm.test(target);
function withTrigger(WrapperComponent) {
  return function WithTrigger(props) {
    const {
      triggerLink,
      ...rest
    } = props;
    const {
      rootBlocks
    } = useContext(BlocksContext);
    const pageProps = usePageProps();
    if (!rootBlocks) {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...props });
    }
    if (!triggerLink || !isValidTrigger(triggerLink)) {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...props });
    }
    const triggerDetails = getBlockById(rootBlocks, triggerLink.substring(1));
    if (!triggerDetails || (triggerDetails == null ? void 0 : triggerDetails.blockName) !== "constellation/modal-dialog") {
      return /* @__PURE__ */ jsx(WrapperComponent, { ...props });
    }
    const triggerComponent = (triggerProps) => /* @__PURE__ */ jsx(BlockModalDialog, { triggerProps, ...triggerDetails });
    return /* @__PURE__ */ jsx(Trigger, { triggered: triggerComponent, onOpen: () => {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2048
        envelope: {
          event_type_id: "5030",
          event_type_version_id: "1",
          event_template_id: "297",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_modal",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_open"
        },
        cms_info: {
          block_id: props.id || "",
          block_type_cd: "modal_dialog",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }, onClose: () => {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2051
        envelope: {
          event_type_id: "2051",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_modal",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_close"
        },
        cms_info: {
          block_id: props.id || "",
          block_type_cd: "modal_dialog",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }, children: /* @__PURE__ */ jsx(WrapperComponent, { ...rest, onClick: yieldCallback((e) => {
      var _a;
      e.preventDefault();
      (_a = props.onClick) == null ? void 0 : _a.call(props, e);
    }) }) });
  };
}
const AnchorWithTrigger = withTrigger(Anchor);
function withAnchor(WrapperComponent) {
  const WithAnchorComponent = (props) => {
    const {
      attrs: {
        link
      }
    } = props;
    const href = usePopulateParamPlaceHolders(link == null ? void 0 : link.url);
    if (link == null ? void 0 : link.url) {
      const rel = [];
      if (link.sponsored) {
        rel.push("nofollow");
        rel.push("sponsored");
      }
      if (link.nofollow) {
        rel.push("nofollow");
      }
      return /* @__PURE__ */ jsx(AnchorWithTrigger, { triggerLink: href, href, rel: rel.length > 0 ? uniq(rel).join(" ") : void 0, target: link.opensInNewTab ? "__blank" : void 0, children: /* @__PURE__ */ jsx(WrapperComponent, { ...props }) });
    }
    return /* @__PURE__ */ jsx(WrapperComponent, { ...props });
  };
  return WithAnchorComponent;
}
export {
  getBlockById,
  isValidTrigger,
  withAnchor,
  withTrigger
};
